import "./App.css";
import "./style/Global.css";
import Nav from "./parts/Nav";
import Home from "./pages/Home";
import Footer from "./parts/Footer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Buy from "./pages/Buy";
import Faq from "./pages/Faq";
import Explore from "./pages/Explore";
import ExploreFrog from "./pages/ExploreFrog";
import Game from "./pages/Game/Game";
import { ToastContainer, toast } from "react-toastify";

function App() {
  return (
    <Router>
      <div className="App">
        <div id="container">
          <ToastContainer />
          <Nav />
          <Switch>
            <Route path="/faq" component={(props) => <Faq />} />
            {/*<Route path="/buy" component={(props) => <Buy />} />*/}
            <Route path="/explore/:id" component={(props) => <ExploreFrog />} />
            <Route path="/explore" component={(props) => <Explore />} />
            {/*<Route path="/game" component={(props) => <Game />} />*/}
            <Route path="/" component={(props) => <Home />} />
          </Switch>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
